import { name as root } from '../actionTypes';

export const name = `${root}/workorders`

export const FETCH_WORK_ORDERS_REQUEST = `${name}/request`
export const FETCH_WORK_ORDERS_SUCCESS = `${name}/success`
export const FETCH_WORK_ORDERS_FAILURE = `${name}/failure`

export const SET_ACTIVE_WORK_ORDER = `${name}/setactiveorder`
export const SET_PREVIOUS_WORK_ORDER = `${name}/setpreviousorder`
export const SET_ACTIVE_TAB = `${name}/setactivetab`